<script setup lang="ts">
import { Card, CardContent } from '@/components/ui/card';
import DeleteUserForm from './Partials/DeleteUserForm.vue';
import UpdatePasswordForm from './Partials/UpdatePasswordForm.vue';
import UpdateProfileInformationForm from './Partials/UpdateProfileInformationForm.vue';
</script>

<template>
  <div class="flex flex-col p-4 max-md:pb-mobile-area-bar-clearance">
    <Card class="shadow-none mb-10">
      <CardContent>
        <UpdateProfileInformationForm class="max-w-xl" />
      </CardContent>
    </Card>
    
    <Card class="shadow-none mb-10">
      <CardContent>
        <UpdatePasswordForm class="max-w-xl" />
      </CardContent>
    </Card>
    
    <Card class="shadow-none mb-10">
      <CardContent>
        <DeleteUserForm class="max-w-xl" />
      </CardContent>
    </Card>
  </div>
</template>
